/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksDisable } from "../../funcs/webhooksDisable.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DisableWebhookRequest$inboundSchema,
};

export const tool$webhooksDisable: ToolDefinition<typeof args> = {
  name: "webhooks-disable",
  description:
    `Disable a webhook. Disabled webhooks will no longer receive events.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksDisable(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
